import React, { useContext, useEffect, useRef, useState } from "react";
import Header3 from "../components/Header3";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import axios from "../AxiosInstance";
import toast from "react-hot-toast";
import { useAuth } from "../context/auth";
import { BASE_URL } from "../config/BaseUrls";
import { LanguageContext } from "../context/LanguageContext";
import {  ensureHttps, resolveBookImageUrl } from "../utils/urlHelpers";
import { ChatState } from "../context/ChatProvider";

const AccountNotification = () => {
  const { lg } = useContext(LanguageContext);

  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);


  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result); // Set the selected image as a base64 URL
        localStorage.setItem("profileImage", reader.result); // Save to localStorage
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  // State for each checkbox
  // const [checkboxes, setCheckboxes] = useState(() => ({
  //   checkbox1: JSON.parse(localStorage.getItem("checkbox1State")) || false,
  //   checkbox2: JSON.parse(localStorage.getItem("checkbox2State")) || false,
  //   checkbox3: JSON.parse(localStorage.getItem("checkbox3State")) || false,
  //   checkbox4: JSON.parse(localStorage.getItem("checkbox4State")) || false,
  // }));

  // // Save state to localStorage when it changes
  // useEffect(() => {
  //   localStorage.setItem(
  //     "checkbox1State",
  //     JSON.stringify(checkboxes.checkbox1)
  //   );
  //   localStorage.setItem(
  //     "checkbox2State",
  //     JSON.stringify(checkboxes.checkbox2)
  //   );
  //   localStorage.setItem(
  //     "checkbox3State",
  //     JSON.stringify(checkboxes.checkbox3)
  //   );
  //   localStorage.setItem(
  //     "checkbox4State",
  //     JSON.stringify(checkboxes.checkbox4)
  //   );
  // }, [checkboxes]);

  // // Generic handler for checkbox state changes
  // const handleCheckboxChange = (checkbox) => {
  //   setCheckboxes((prev) => ({
  //     ...prev,
  //     [checkbox]: !prev[checkbox],
  //   }));
  // };

  // const handleSubmit = async () => {
  //   await axios.post("/api/vi/auth/update-newsletter", {
  //     preferences: checkboxes,
  //   });
  // };
  // Initial state from localStorage or default values
  const getSavedPreferences = () => {
    const savedPreferences = localStorage.getItem("newsletterPreferences");
    return savedPreferences
      ? JSON.parse(savedPreferences)
      : {
          checkbox1: true,
          checkbox2: true,
          checkbox3: true,
          checkbox4: true,
        };
  };

  const [checkboxes, setCheckboxes] = useState(getSavedPreferences);

  // Handle checkbox change
  const handleCheckboxChange = async (name) => {
    const updated = {
      ...checkboxes,
      [name]: !checkboxes[name],
    };
    setCheckboxes(updated);

    // Save the updated preferences to localStorage
    localStorage.setItem("newsletterPreferences", JSON.stringify(updated));

    try {
      const res = await axios.post("api/v1/auth/update-newsletter", {
        preferences: updated,
      });
      if (res.data.success) {
        toast.success("Preferences updated!");
      } else {
        toast.error("Update failed!");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!");
    }
  };

  const [show, setShow] = useState(false); // For signup modal
  const handleClose = () => {
    setShow(false); // Close signup modal
  };
  // Handle opening signup modal
  const handleShow = () => {
    setShow(true); // Open signup modal
  };

  // Eamil Change

  const [eShow, setEShow] = useState(false); // For signup modal
  const handleCloseE = () => {
    setEShow(false); // Close signup modal
  };
  // Handle opening signup modal
  const handleShowE = () => {
    setEShow(true); // Open signup modal
  };

  const [dShow, setDShow] = useState(false); // For signup modal
  const handleDClose = () => {
    setDShow(false); // Close signup modal
  };
  // Handle opening signup modal
  const handleDShow = () => {
    setDShow(true); // Open signup modal
  };

  const [dMShow, setDMShow] = useState(false); // For signup modal
  const handleDMClose = () => {
    setDMShow(false); // Close signup modal
  };
  // Handle opening signup modal
  const handleDMShow = () => {
    setDMShow(true); // Open signup modal
    setDShow(false);
    // Automatically close the modal after 3 seconds
    setTimeout(() => {
      setDMShow(false);
    }, 3000);
  };

  const navigate = useNavigate();

  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const [passwordNewVisible, setPasswordNewVisible] = useState(false);

  const togglePasswordNewVisibility = () => {
    setPasswordNewVisible((prevState) => !prevState);
  };

  const [alertVisible, setAlertVisible] = useState(false);

  const handleSaveChanges = () => {
    setAlertVisible(true); // Show the alert

    setTimeout(() => setAlertVisible(false), 6000); // Hide the alert after 3 seconds
  };

  const handleCloseAlert = () => {
    setAlertVisible(false); // Manually close the alert
  };

  // =============== Integration =========================

  // ===============Change Password Integration=========================

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [auth, setAuth] = useAuth(); // If using Context API


  const handleSubmitChangePassword = async () => {
    // const currentPassword = document.getElementById("cpassword").value;
    // const newPassword = document.getElementById("npassword").value;
    // const confirmPassword = document.getElementById("cnpassword").value;

    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error("All fields are required.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Password do not match.");
      return;
    }

    try {
      const response = await axios.post(
        "api/v1/admin/change-password",
        {
          currentPassword,
          newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`, // Pass the current token
          },
        }
      );

      if (response.data.success) {
        const { newToken } = response.data; // Assuming the server provides a new token

        // Update auth state and localStorage
        const updatedAuth = {
          ...auth,
          token: newToken,
        };
        setAuth(updatedAuth);
        localStorage.setItem("auth", JSON.stringify(updatedAuth));

        toast.success(response.data.message);
        setCurrentPassword(""); // Clear the input field
        setNewPassword(""); // Clear the new password field
        setConfirmPassword(""); // Clear the confirm password field
        setShow(false);
        setAuth({
          ...auth,
          user: null,
          token: "",
        });
        localStorage.removeItem("auth");
        navigate("/");
      } else {
        toast.error(response.data.message || "Failed to change password.");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      toast.error(error.response?.data?.message || "Something went wrong.");
    }
  };

  // ===============Change Password Integration=========================

  // ===============Change Email Integration=========================
  const [currentEmail, setCurrentEmail] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");

  const handleSubmitChangeEmail = async () => {
    // const currentPassword = document.getElementById("cpassword").value;
    // const newPassword = document.getElementById("npassword").value;
    // const confirmPassword = document.getElementById("cnpassword").value;

    if (!currentEmail || !newEmail || !confirmEmail) {
      toast.error("All fields are required.");
      return;
    }

    if (newEmail !== confirmEmail) {
      toast.error("Email do not match.");
      return;
    }

    try {
      const response = await axios.post(
        "api/v1/admin/change-email",
        {
          currentEmail,
          newEmail,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`, // Pass the current token
          },
        }
      );

      if (response.data.success) {
        const { newToken } = response.data; // Assuming the server provides a new token

        // Update auth state and localStorage
        const updatedAuth = {
          ...auth,
          token: newToken,
        };
        setAuth(updatedAuth);
        localStorage.setItem("auth", JSON.stringify(updatedAuth));

        toast.success(response.data.message);
        setCurrentEmail(""); // Clear the input field
        setNewEmail(""); // Clear the new password field
        setConfirmEmail(""); // Clear the confirm password field
        setShow(false);
        setAuth({
          ...auth,
          user: null,
          token: "",
        });
        localStorage.removeItem("auth");
        navigate("/");
      } else {
        toast.error(response.data.message || "Failed to change eamil.");
      }
    } catch (error) {
      console.error("Error changing eamil:", error);
      toast.error(error.response?.data?.message || "Something went wrong.");
    }
  };

  // ===============Change Email Integration=========================

  // ==========================Deleted Account====================

  const [password, setPassword] = useState("");

  const handleDeleteAccount = async () => {
    // const password = document.getElementById("password").value;

    if (!password) {
      toast.error("Please enter your password to confirm.");
      return;
    }

    try {
      const response = await axios.delete(`api/v1/auth/delete-account/${password}`, {
        // headers: {
        //   Authorization: `Bearer ${localStorage.getItem("auth")}`,
        // },

        headers: {
          Authorization: `Bearer ${auth.token}`, // Pass the current token
        },
      
      });

      if (response.data.success) {
        toast.success("Your Account deleted successfully.");
        localStorage.removeItem("auth");
        setAuth({ user: null, token: "" });
        setDShow(false);
        handleDMShow(true);
        setPassword("");
        setTimeout(() => {
          navigate("/");
        }, 3500);
      } else {
        toast.error(response.data.message || "Failed to delete account.");
      }
    } catch (error) {
      console.error("Error deleting account:", error);
      toast.error(error.response?.data?.message || "Something went wrong.");
    }
  };

  // ==========================Deleted Account====================

  // FAtch User Details

  const userId = auth?.user?._id;

  const {
    selectedChat,
    setSelectedChat,
    user,
    setUser,
    notification,
    setChats,
    setNotification,
  } = ChatState();

  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return; // Don't make API call if userId is undefined
      try {
        const res = await axios.get(`api/v1/auth/user-profile/${userId}`);
        setUser(res.data.data);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchUser();
  }, [userId]);


  return (
    <>
      <div className="profilheder">
        <Header3 />
      </div>
      {/* Alert */}

      {alertVisible && (
        <div
          style={{
            position: "absolute", // Overlay on top
            top: "14%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "orange",
            color: "white",
            padding: "10px 10px",
            borderRadius: "5px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // width: "400px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
          }}
        >
          {/* Tick Icon */}
          <div
            style={{
              backgroundColor: "white",
              color: "green",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              border: "1px solid green",
            }}
          >
            ✓
          </div>
          <div className="fontmobil" style={{ flex: 1 }}>
            Your Account information has been updated
          </div>
          {/* Close Icon */}
          <div
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
            onClick={handleCloseAlert}
          >
            ×
          </div>
        </div>
      )}

      <div className="container mx-auto px-4 lg:!px-0 py-6">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
          {/* Sidebar */}
          <div className="w-full lg:w-64 flex-shrink-0">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              {/* Profile Image Section */}
              <div className="flex flex-col items-center mb-6">
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                 {user && (
                  <div className="relative mb-4">
                    <img
                    src={
                      selectedImage ||
                      (user?.profileImage
                        ? user?.profileImage?.startsWith("http")
                          ? ensureHttps(user?.profileImage) // ✅ external URL - ensure HTTPS
                          : ensureHttps(`${BASE_URL}/uploads/${user.profileImage}`) // ✅ internal URL - ensure HTTPS
                        : require("../pages/image/addphotoiconplus.png"))
                    }
                      alt="Profile"
                      className="rounded-full w-24 h-24 object-cover cursor-pointer border-2 border-gray-200 hover:border-[#34C3C9] transition-colors"
                      onClick={handleButtonClick}
                    />
                    <div className="absolute bottom-0 right-0 bg-[#34C3C9] rounded-full p-1.5 cursor-pointer hover:bg-[#2BB3BA] transition-colors">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                  </div>
                )}
                <h2 className="text-xl font-bold text-gray-900 mb-2">{user?.name}</h2>
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                  onClick={handleButtonClick}
                >
                  {lg?.uploadp || "Update photo"}
                </button>
              </div>

              {/* Navigation Links */}
              <div className="space-y-2 border-t border-gray-200 pt-4">
                <Link
                  to="/profile"
                  className="flex items-center px-2 py-2.5 text-base font-medium text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
                >
                  {lg?.pprofile || "Personal Profile"}
                </Link>
                <Link
                  to="/accountnotification"
                  className="flex items-center px-2 py-2.5 text-base font-semibold text-[#34C3C9] bg-[#34C3C91a] rounded-lg"
                >
                  {lg?.accnotifi || "Account Notification"}
                </Link>
                {user?.seller === "Yes" && (
                  <Link
                    to="/personal-seller"
                    className="flex items-center px-2 py-2.5 text-base font-medium text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
                  >
                    Bookseller's details
                  </Link>
                )}
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 lg:p-8 space-y-6">
                {/* <form className="textleft mx-auto ">
                  <div className="mbbom">
                    <label
                      htmlFor="email"
                      className="form-label text-dark ftzevtt fw600 fs-5 text-left"
                      style={{
                        lineHeight: "27.24px",
                      }}
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control namewidd fw600 fs-5 ftzevtt rounded-0 placeholder-login"
                      id="email"
                      required
                      style={{
                        border: "1px solid #6D6D6D",
                        width: "539px",
                        height: "40px",

                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>

                  <div className="mbbom">
                    <label
                      htmlFor="password"
                      className="form-label text-dark fw600 ftzevtt fs-5 text-left"
                      style={{
                        lineHeight: "27.24px",
                      }}
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      className="form-control w-100 fw600 ftzevtt fs-5 rounded-0 placeholder-login"
                      id="password"
                      style={{
                        border: "1px solid #6D6D6D",
                        maxWidth: "539px",
                        height: "40px",

                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>
                </form> */}

                {/* <div
                  className="fw-normal ftzevtt text-dark text-decoration-underline"
                  style={{
                    fontSize: "18px",
                    lineHeight: "24.51px",
                    cursor: "pointer",
                  }}
                  onClick={handleShow}
                >
                  Change your password
                </div> */}

              {/* Change Password Section */}
              <div className="border-b border-gray-200 pb-6">
                <h3 className="text-lg font-bold text-gray-900 mb-1">{lg?.cypass || "Change your password"}</h3>
                <p className="text-sm text-gray-600 mb-4">{lg?.cypasstext || "When you change your password, you will be automatically signed out from your other sessions"}</p>
                <button
                  onClick={handleShow}
                  className="px-6 py-2.5 bg-[#34C3C9] hover:bg-[#2BB3BA] text-white font-semibold rounded-lg transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                >
                  {lg?.cpass || "Change password"}
                </button>
              </div>

              {/* Change Email Section */}
              <div className="border-b border-gray-200 pb-6">
                <h3 className="text-lg font-bold text-gray-900 mb-1">{lg?.cyemail || "Change your e-mail"}</h3>
                <p className="text-sm text-gray-600 mb-4">{lg?.cyemailtext || "When you change your e-mail, you will be automatically signed out from your other sessions"}</p>
                <button
                  onClick={handleShowE}
                  className="px-6 py-2.5 bg-[#34C3C9] hover:bg-[#2BB3BA] text-white font-semibold rounded-lg transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                >
                  {lg?.cemail || "Change e-mail"}
                </button>
              </div>

              {/* Notification Preferences */}
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{lg?.notifi || "Notification"}</h3>
                <p className="text-sm text-gray-600 mb-4">{lg?.emailmeab || "Email me about"}</p>
                
                <div className="space-y-3">
                  <label className="flex items-center gap-3 cursor-pointer group">
                    <input
                      type="checkbox"
                      checked={checkboxes.checkbox1}
                      onChange={() => handleCheckboxChange("checkbox1")}
                      className="w-5 h-5 text-[#34C3C9] border-gray-300 rounded focus:ring-[#34C3C9] focus:ring-2 cursor-pointer"
                    />
                    <span className="text-base font-medium text-gray-700 group-hover:text-gray-900">
                      {lg?.lastesttext || "Latest trending books"}
                    </span>
                  </label>

                  <label className="flex items-center gap-3 cursor-pointer group">
                    <input
                      type="checkbox"
                      checked={checkboxes.checkbox2}
                      onChange={() => handleCheckboxChange("checkbox2")}
                      className="w-5 h-5 text-[#34C3C9] border-gray-300 rounded focus:ring-[#34C3C9] focus:ring-2 cursor-pointer"
                    />
                    <span className="text-base font-medium text-gray-700 group-hover:text-gray-900">
                      {lg?.upcomtext || "Upcoming month's new books"}
                    </span>
                  </label>

                  <label className="flex items-center gap-3 cursor-pointer group">
                    <input
                      type="checkbox"
                      checked={checkboxes.checkbox3}
                      onChange={() => handleCheckboxChange("checkbox3")}
                      className="w-5 h-5 text-[#34C3C9] border-gray-300 rounded focus:ring-[#34C3C9] focus:ring-2 cursor-pointer"
                    />
                    <span className="text-base font-medium text-gray-700 group-hover:text-gray-900">
                      {lg?.baevent || "Books, Authors and events I'd enjoy"}
                    </span>
                  </label>

                  <label className="flex items-center gap-3 cursor-pointer group">
                    <input
                      type="checkbox"
                      checked={checkboxes.checkbox4}
                      onChange={() => handleCheckboxChange("checkbox4")}
                      className="w-5 h-5 text-[#34C3C9] border-gray-300 rounded focus:ring-[#34C3C9] focus:ring-2 cursor-pointer"
                    />
                    <span className="text-base font-medium text-gray-700 group-hover:text-gray-900">
                      {lg?.newoff || "New Ofellio features"}
                    </span>
                  </label>
                </div>
              </div>

              {/* Delete Account */}
              <div className="pt-6 border-t border-gray-200">
                <button
                  onClick={handleDShow}
                  className="text-red-600 hover:text-red-700 font-medium underline transition-colors"
                >
                  Delete Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Password Change */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="custom-modal custom-modalhegit"
      >
        <Modal.Header className=" border-0 ">
          <img
            className=" border-0 closebtn closebtnchpas "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center ptmodelpass11 text-dark fw-bold mt-3 modeltitle"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
          }}
        >
          {/* Change your password */}
          {lg?.cypass}
        </Modal.Title>
        <Modal.Body className="modelbody text-center">
          <form
            className="textleft margg mt-3"
            onSubmit={handleSubmitChangePassword}
          >
            <div className="mb-3">
              <label
                htmlFor="cpassword"
                className="form-label fw600 fs-5 ftlink text-left"
              >
                {/* Current Password */}
                {lg?.curnpass}
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type={passwordVisible ? "text" : "password"}
                  className="form-control w-100 fs-5 outline-none ftzevtt rounded-4 placeholder-login"
                  id="cpassword"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  style={{ border: "0.1px " }}
                />

                <img
                  className="m-3"
                  src={require("./image/eyepassw.png")}
                  width="24"
                  height="24"
                  onClick={togglePasswordVisibility}
                />
                {/* <i
                    className={`bi ${
                      passwordVisible ? "bi-eye" : "bi-eye-slash"
                    }`}
                  ></i> */}
              </div>
            </div>

            <div className="mb-3">
              <label
                htmlFor="npassword"
                className="form-label fw600 fs-5 ftlink text-left"
              >
                {/* New Password */}
                {lg?.newpass}
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type={passwordNewVisible ? "text" : "password"}
                  className="form-control w-100 fs-5 outline-none ftzevtt rounded-4 placeholder-login"
                  id="npassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  style={{ border: "0.1px " }}
                />

                <img
                  className="m-3"
                  src={require("./image/eyepassw.png")}
                  width="24"
                  height="24"
                  onClick={togglePasswordNewVisibility}
                />
              </div>
            </div>

            <div className="mb-3">
              <label
                htmlFor="cnpassword"
                className="form-label fw600 fs-5 ftlink text-left"
              >
                {/* Confirm New Password */}
                {lg?.cnewpass}
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type={passwordNewVisible ? "text" : "password"}
                  className="form-control w-100 fs-5 outline-none ftzevtt rounded-4 placeholder-login"
                  id="cnpassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  style={{ border: "0.1px " }}
                />

                <img
                  className="m-3"
                  src={require("./image/eyepassw.png")}
                  width="24"
                  height="24"
                  onClick={togglePasswordNewVisibility}
                />
                {/* <i
                    className={`bi ${
                      passwordVisible ? "bi-eye" : "bi-eye-slash"
                    }`}
                  ></i> */}
              </div>
            </div>
          </form>
          <div className="mt-4 text-center">
            <button
              className="w-100  eventcrtwid fw600 fs-5 !text-white text-center rounded-1 border-0"
              style={{
                maxWidth: "167px",
                height: "44px",
                backgroundColor: "#34C3C9",
              }}
              onClick={handleSubmitChangePassword}
            >
              {/* Submit */}
              {lg?.submitbtn}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={eShow}
        onHide={handleCloseE}
        centered
        className="custom-modal custom-modalhegit"
      >
        <Modal.Header className=" border-0 ">
          <img
            className=" border-0 closebtn closebtnchpas "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleCloseE}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center ptmodelpass11 text-dark fw-bold mt-3 modeltitle"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
          }}
        >
          {/* Change your e-mail */}
          {lg?.cyemail}
        </Modal.Title>
        <Modal.Body className="modelbody text-center">
          <form
            className="textleft margg mt-3"
            onSubmit={handleSubmitChangeEmail}
          >
            <div className="mb-3">
              <label
                htmlFor="cemail"
                className="form-label fw600 fs-5 ftlink text-left"
              >
                {/* Current e-mail */}
                {lg?.curnemail}
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type="email"
                  className="form-control w-100 fs-5 outline-none ftzevtt rounded-4 placeholder-login"
                  id="cemail"
                  value={currentEmail}
                  onChange={(e) => setCurrentEmail(e.target.value)}
                  style={{ border: "0.1px " }}
                />
              </div>
            </div>

            <div className="mb-3">
              <label
                htmlFor="nemail"
                className="form-label fw600 fs-5 ftlink text-left"
              >
                {/* New e-mail */}
                {lg?.newemail}
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type="email"
                  className="form-control w-100 fs-5 outline-none ftzevtt rounded-4 placeholder-login"
                  id="nemail"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  style={{ border: "0.1px " }}
                />
              </div>
            </div>

            <div className="mb-3">
              <label
                htmlFor="cnemail"
                className="form-label fw600 fs-5 ftlink text-left"
              >
                {/* Confirm New e-mail */}
                {lg?.cnewemail}
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type="email"
                  className="form-control w-100 fs-5 outline-none ftzevtt rounded-4 placeholder-login"
                  id="cnemail"
                  value={confirmEmail}
                  onChange={(e) => setConfirmEmail(e.target.value)}
                  style={{ border: "0.1px " }}
                />
              </div>
            </div>
          </form>
          <div className="mt-4 text-center">
            <button
              className="w-100  eventcrtwid fw600 fs-5 !text-white text-center rounded-1 border-0"
              style={{
                maxWidth: "167px",
                height: "44px",
                backgroundColor: "#34C3C9",
              }}
              onClick={handleSubmitChangeEmail}
            >
              {/* Submit */}
              {lg?.submitbtn}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Delete model */}
      <Modal
        show={dShow}
        onHide={handleDClose}
        centered
        className="custom-modal custom-modalhegitdelt "
      >
        <Modal.Header className=" border-0 ">
          <img
            className=" border-0 closebtn closebtnchpas "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleDClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center ptmodelpass11 text-dark fw-bold mt-3 modeltitle"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
          }}
        >
          {/* Delete your account */}
          {lg?.delyacc}
        </Modal.Title>
        <Modal.Body className="modelbody text-center">
          <div className="text-center margg mt-sm-4 mt-2">
            <div className="ftnotfi fw600" style={{ fontSize: "22px" }}>
              {/* We are very sorry you want to leave us! */}
              {lg?.sorrytext}
            </div>
            <div className="ftnotfi fw600" style={{ fontSize: "22px" }}>
              {/* Are you sure you want to do this? */}
              {lg?.suretext}
            </div>
          </div>
          <div className="fs-5  fw-normal ftzevtt mt-4">
            {/* If you decide to use Ofellio again, you'll need to create a new
            account. */}
            {lg?.decitext}
          </div>

          <form
            className="  margg mt-4 mx-auto "
            onSubmit={handleDeleteAccount}
          >
            <div className="mbbom">
              <label
                htmlFor="password"
                className="form-label text-center text-dark fw600 ftzevtt fs-5 mx-auto"
                style={{
                  lineHeight: "27.24px",
                }}
              >
                {/* Password */}
                {lg?.pass}
              </label>
              <input
                type="password"
                className="form-control  mx-auto  w-100 fw600 ftzevtt fs-5 rounded-2 placeholder-login"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "400px",
                  height: "40px",

                  lineHeight: "27.24px",
                  color: "#7B7B7B",
                }}
              />
            </div>
          </form>

          <div className="mt-4 text-center">
            <button
              type="submit"
              className="w-100  eventcrtwid fw600 fs-5 !text-white text-center rounded-1 border-0"
              style={{
                maxWidth: "167px",
                height: "44px",
                backgroundColor: "#34C3C9",
              }}
              // onClick={handleDMShow}
              onClick={handleDeleteAccount}
            >
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Delete msg */}

      <Modal
        show={dMShow}
        onHide={handleDMClose}
        centered
        className="customdelmsh "
      >
        <Modal.Header className=" border-0 d-none ">
          <img
            className=" border-0 closebtn closebtnchpas "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleDMClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center ptmodelpass11 text-dark fw-bold my-sm-5 my-4 ftnotfi"
          style={{
            fontSize: "26px",
            lineHeight: "43.58px",
          }}
        >
          Your account will be deleted.
        </Modal.Title>
      </Modal>
    </>
  );
};

export default AccountNotification;
